var _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBookingsIcon(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M58.6667 15.9999V22.4533C58.6667 26.6666 56 29.3333 51.7867 29.3333H42.6667V10.6933C42.6667 7.73325 45.0935 5.33325 48.0535 5.33325C50.9601 5.35992 53.6268 6.53325 55.5468 8.45325C57.4668 10.3999 58.6667 13.0666 58.6667 15.9999Z",
    stroke: "#046242",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.33325 18.6666V55.9999C5.33325 58.2133 7.83985 59.4666 9.59985 58.1333L14.1599 54.7199C15.2266 53.9199 16.7199 54.0266 17.6799 54.9866L22.1065 59.4399C23.1465 60.4799 24.8533 60.4799 25.8933 59.4399L30.3733 54.9599C31.3066 54.0266 32.7999 53.9199 33.8399 54.7199L38.4 58.1333C40.16 59.4399 42.6666 58.1866 42.6666 55.9999V10.6666C42.6666 7.73325 45.0666 5.33325 47.9999 5.33325H18.6666H15.9999C7.99992 5.33325 5.33325 10.1066 5.33325 15.9999V18.6666Z",
    stroke: "#046242",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M16 24H32",
    stroke: "#046242",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M18 34.6667H30",
    stroke: "#046242",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBookingsIcon);
export default __webpack_public_path__ + "static/media/bookings-icon.94a54bd5da6493ef4c641c1ea204a749.svg";
export { ForwardRef as ReactComponent };